import React from "react";
import Helmet from "react-helmet";
import { Dialog } from "@mui/material";
import { X } from "react-feather";
import SignupForm from "../../read/components/SignupForm";
import readStyles from "../../read/read.module.css";
import styles from "./bookDemoModal.module.css";

const BookDemoModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{ className: styles.Paper, elevation: 0 }}
      BackdropProps={{ className: styles.Backdrop }}
    >
      <Helmet>
        <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      </Helmet>
      <div className={`${readStyles.SignupCard} ${styles.Card}`}>
        <button type="button" className={styles.CloseBU} onClick={onClose} aria-label="Close">
          <X size={16} />
        </button>
        <SignupForm
          source="home"
          title="Reserve Your Demo"
          subtitle="Pick a time with our team for a personalized 30-minute walkthrough."
          buttonText="Book a Demo"
          note="We'll only use your email to schedule your demo."
          successText="to schedule your PropertyDek demo."
          onDone={onClose}
        />
      </div>
    </Dialog>
  );
};

export default BookDemoModal;
